module.exports = __webpack_public_path__ + "173f8a296b4ed73d6913230e2245e373.ttf";